import Typography from "@components_v2/typography/typography";
import { IconBack, IconChevronRight } from "@mzc-cloudplex/icons";
import { Box, Grid, IconButton, Stack, Tooltip } from "@mzc-pdc/ui";
import theme from "@styles/theme";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import menuService from "@services/menuService";

const findObjectById = (menuArray, targetId) => {
    // 검색 전 ID로 맵을 구성하는 방법 (사전 처리 필요)
    const menuMap = new Map();
    const relationMap = new Map();

    // 모든 메뉴를 맵에 등록
    for (const menu of menuArray) {
        menuMap.set(menu.id, menu);

        if (menu.subMenus && menu.subMenus.length) {
            for (const subMenu of menu.subMenus) {
                menuMap.set(subMenu.id, subMenu);
                relationMap.set(subMenu.id, menu);
            }
        }
    }

    // ID로 바로 검색
    if (menuMap.has(targetId)) {
        const found = menuMap.get(targetId);
        const parent = relationMap.get(targetId);

        return parent ? [parent, found] : [found];
    }

    return [];
};

const CustomMenuBreadcrumb = ({ currentItem, prev }) => {
    const location = useLocation();
    const customMenus = useSelector(({ customMenus }) => customMenus);

    const menuId = useMemo(() => {
        return location.pathname.split("/customMenuSets/")?.[1]?.split("/")?.[1];
    }, [location.pathname]);

    const breadcrumb = useMemo(() => {
        if (!customMenus?.data) return [];
        const result = findObjectById(customMenus.data, menuId);
        return result;
    }, [customMenus, menuId]);

    return (
        <Stack direction={"row"} spacing={theme.spacing(2)} sx={{ alignItems: "center" }}>
            {breadcrumb.map((item, index) => (
                <React.Fragment key={item.id}>
                    <Grid item>
                        <Typography variant="h3" color={theme.palette.greySecondary.main}>
                            {item.name}
                        </Typography>
                    </Grid>
                    {index < breadcrumb.length - 1 && (
                        <Grid item>
                            <IconChevronRight size={16} htmlColor={theme.palette.greySecondary[600]} />
                        </Grid>
                    )}
                </React.Fragment>
            ))}
            <Grid item sx={{ display: "flex", flexDirection: "row" }}>
                {prev && prev}
                {currentItem && (
                    <Stack direction={"row"}>
                        {breadcrumb.length > 0 && ( //Note: custom menus를 아직 불러오지 못해 breadcrumb이 없는 경우(ex: LNB 없는 에셋 상세) 아이콘을 표시하면 안 됨
                            <Box>
                                <IconChevronRight size={16} htmlColor={theme.palette.greySecondary[600]} />
                            </Box>
                        )}
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Typography variant="h3" color={theme.palette.greySecondary.main}>
                                {currentItem.name}
                            </Typography>
                        </Box>
                    </Stack>
                )}
            </Grid>
        </Stack>
    );
};

export default CustomMenuBreadcrumb;
